export const aprilUppercase = "GsS9te";
export default {aprilUppercase};